import { FormBuilder, FormArray, Validators } from '@angular/forms';

export function referencesGroup (formBuilder: FormBuilder): FormArray {
  return formBuilder.array([]);
}
